/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Typ`
};

const da_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Køn`
};

const de_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Geschlecht`
};

const en_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Gender`
};

const es_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Como`
};

const fr_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Genre`
};

const hu_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Nem`
};

const it_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Sesso`
};

const nl_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Geslacht`
};

const pl_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Płeć`
};

const pt_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Género`
};

const sv_attributes_gender = /** @type {(inputs: {}) => string} */ () => {
	return `Kön`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_gender = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_gender(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_gender", locale)
	if (locale === "cs") return cs_attributes_gender(inputs)
	if (locale === "da") return da_attributes_gender(inputs)
	if (locale === "de") return de_attributes_gender(inputs)
	if (locale === "en") return en_attributes_gender(inputs)
	if (locale === "es") return es_attributes_gender(inputs)
	if (locale === "fr") return fr_attributes_gender(inputs)
	if (locale === "hu") return hu_attributes_gender(inputs)
	if (locale === "it") return it_attributes_gender(inputs)
	if (locale === "nl") return nl_attributes_gender(inputs)
	if (locale === "pl") return pl_attributes_gender(inputs)
	if (locale === "pt") return pt_attributes_gender(inputs)
	return sv_attributes_gender(inputs)
};
export { attributes_gender as "attributes.gender" }